// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__MHeGX","persons":"styles_persons__R48F5"};